"use strict";

import {init as productListPreviewsInit} from './src/productListPreviews';
import productQtyInputDisplayEstimate from './src/productQtyInputDisplayEstimate';
import productCategoryViewProducts from './src/productCategoryViewProducts';
import productCategoryViewCategory from './src/productCategoryViewCategory';

productListPreviewsInit();
productQtyInputDisplayEstimate.init();
productCategoryViewProducts.init();
productCategoryViewCategory.init();
